import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { rem } from "./auth-service-tools172.js";
import "react";
import { getRadius } from "./auth-service-tools185.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { getThemeColor } from "./auth-service-tools208.js";
import { getContrastColor } from "./auth-service-tools214.js";
import { getAutoContrastValue } from "./auth-service-tools215.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { getPositionVariables } from "./auth-service-tools373.js";
import classes from "./auth-service-tools374.js";
const defaultProps = {
  position: "top-end",
  offset: 0,
  inline: false,
  withBorder: false,
  disabled: false,
  processing: false
};
const varsResolver = createVarsResolver((theme, _ref) => {
  let {
    color,
    position,
    offset,
    size,
    radius,
    zIndex,
    autoContrast
  } = _ref;
  return {
    root: {
      "--indicator-color": color ? getThemeColor(color, theme) : void 0,
      "--indicator-text-color": getAutoContrastValue(autoContrast, theme) ? getContrastColor({
        color,
        theme,
        autoContrast
      }) : void 0,
      "--indicator-size": rem(size),
      "--indicator-radius": radius === void 0 ? void 0 : getRadius(radius),
      "--indicator-z-index": zIndex == null ? void 0 : zIndex.toString(),
      ...getPositionVariables(position, offset)
    }
  };
});
const Indicator = factory((_props, ref) => {
  const props = useProps("Indicator", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    children,
    position,
    offset,
    inline,
    label,
    radius,
    color,
    withBorder,
    disabled,
    processing,
    zIndex,
    autoContrast,
    mod,
    ...others
  } = props;
  const getStyles = useStyles({
    name: "Indicator",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver
  });
  return /* @__PURE__ */jsxRuntimeExports.jsxs(Box, {
    ref,
    ...getStyles("root"),
    mod: [{
      inline
    }, mod],
    ...others,
    children: [!disabled && /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
      mod: {
        "with-label": !!label,
        "with-border": withBorder,
        processing
      },
      ...getStyles("indicator"),
      children: label
    }), children]
  });
});
Indicator.classes = classes;
Indicator.displayName = "@mantine/core/Indicator";
export { Indicator };